export default "__VITE_ASSET__B84rXA92__"